import React from 'react';
import { financeFormat } from '@sg/utils/common';
import type { TMetricScope } from '../../utils/normalizeMetricAxisRows';

const burnRateHeaderStyle: React.CSSProperties = {
  textAlign: 'right',
  lineHeight: '20px',
  whiteSpace: 'nowrap',
};

const PORTFOLIO_BURN_RATE_COLUMN_WIDTH = {
  date: 88,
  rdCost: 88,
  smCost: 88,
  gaNonRD: 88,
  otherCost: 88,
};

// Column width configurations organized by scope
const STUDIO_BURN_RATE_COLUMN_WIDTH = {
  date: 100,
  rdCost: 88,
  smCost: 88,
  gaNonRD: 160,
  otherCost: 88,
};

export const getBurnRateColumns = (scope: TMetricScope = 'studio') => {
  const axisHeader = scope === 'portfolio' ? 'Studio' : 'Date';
  
  // Select the appropriate width configuration based on scope
  const columnWidths = scope === 'portfolio' 
    ? PORTFOLIO_BURN_RATE_COLUMN_WIDTH 
    : STUDIO_BURN_RATE_COLUMN_WIDTH;

  return [
    {
      header: axisHeader,
      dataIndex: 'date',
      key: 'date',
      width: columnWidths.date,
      render: (item: any) => (
        <div style={{ whiteSpace: 'nowrap' }}>{item?.date}</div>
      ),
    },
    {
      header: <div style={burnRateHeaderStyle}>R&D Cost</div>,
      title: 'R&D Cost',
      dataIndex: 'RDCost',
      key: 'RDCost',
      width: columnWidths.rdCost,
      format: (val: number) => financeFormat(val, 1),
      align: 'right',
      render: (item: any) => (
        <div style={{ textAlign: 'right', textWrap: 'nowrap' }}>
          {financeFormat(item?.RDCost, 1)}
        </div>
      ),
    },
    {
      header: <div style={burnRateHeaderStyle}>S&M Cost</div>,
      title: 'S&M Cost',
      dataIndex: 'SMExpenses',
      key: 'SMExpenses',
      width: columnWidths.smCost,
      format: (val: number) => financeFormat(val, 1),
      align: 'right',
      render: (item: any) => (
        <div style={{ textAlign: 'right', textWrap: 'nowrap' }}>
          {financeFormat(item?.SMExpenses, 1)}
        </div>
      ),
    },
    {
      header: <div style={burnRateHeaderStyle}>G&A - Non R&D expense</div>,
      title: 'G&A - Non R&D expense',
      dataIndex: 'GANonRDExpense',
      key: 'GANonRDExpense',
      width: columnWidths.gaNonRD,
      format: (val: number) => financeFormat(val, 1),
      align: 'right',
      render: (item: any) => (
        <div style={{ textAlign: 'right', textWrap: 'nowrap' }}>
          {financeFormat(item?.GANonRDExpense, 1)}
        </div>
      ),
    },
    {
      header: <div style={{ ...burnRateHeaderStyle, paddingRight: '20px' }}>Other Cost</div>,
      title: 'Other Cost',
      dataIndex: 'OtherCopsExclChannel',
      key: 'OtherCopsExclChannel',
      width: columnWidths.otherCost,
      format: (val: number) => financeFormat(val, 1),
      align: 'right',
      render: (item: any) => (
        <div style={{ textAlign: 'right', textWrap: 'nowrap', paddingRight: '20px' }}>
          {financeFormat(item?.OtherCopsExclChannel, 1)}
        </div>
      ),
    },
  ];
};
